"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FeHero =
/*#__PURE__*/
function (_Component) {
  _inherits(FeHero, _Component);

  function FeHero() {
    _classCallCheck(this, FeHero);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeHero).apply(this, arguments));
  }

  _createClass(FeHero, [{
    key: "render",
    value: function render() {
      /** Minimum condition required to render*/

      /** Rendering of component */
      var className = (0, _classnames.default)('fe-hero', this.props.className);
      return _react.default.createElement("div", {
        className: className
      }, this.props.summaryContent || this.props.actionContent ? _react.default.createElement("div", {
        className: "fe-hero__head"
      }, this.props.summaryContent && _react.default.createElement("div", {
        className: "fe-hero__head-summary"
      }, this.props.summaryContent), this.props.actionContent && _react.default.createElement("div", {
        className: "fe-hero__head-actions"
      }, this.props.actionContent)) : null, this.props.title || this.props.titleContent ? _react.default.createElement("div", {
        className: "fe-hero__title"
      }, this.props.title && _react.default.createElement("h1", {
        className: "page-title fe-hero__title-text"
      }, this.props.title), this.props.titleContent) : null, this.props.descriptionContent && _react.default.createElement("div", {
        className: "fe-hero__body"
      }, this.props.descriptionContent));
    }
  }]);

  return FeHero;
}(_react.Component);

FeHero.defaultProps = {
  title: null,
  summaryContent: null,
  actionContent: null,
  titleContent: null,
  descriptionContent: null
};
FeHero.propTypes = {
  /** Provide page title for hero*/
  title: _propTypes.default.string,

  /** Provide summary content for page like breadcrumb or 10 words*/
  summaryContent: _propTypes.default.node,

  /** Provide action buttons*/
  actionContent: _propTypes.default.node,

  /** Provide title content like 'badge'*/
  titleContent: _propTypes.default.node,

  /** Provide description content for page*/
  descriptionContent: _propTypes.default.node
};
FeHero.displayName = 'FeHero';
var _default = FeHero;
exports.default = _default;